import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { CopyButton } from '@/components/ui/CopyButton'
import { Demo, DsSection } from '../primitives'

const VARIANTS: { variant: BadgeVariant; label: string }[] = [
  { variant: 'default', label: 'Best value' },
  { variant: 'secondary', label: 'Current insurer' },
  { variant: 'success', label: 'Active' },
  { variant: 'warning', label: 'Missing' },
  { variant: 'destructive', label: 'Expired' },
  { variant: 'outline', label: 'Carrier estimate' },
]

function VariantDemo({ variant, label }: { variant: BadgeVariant; label: string }) {
  const value = `variant="${variant}"`
  return (
    <div className="flex flex-col items-start gap-2">
      <Badge variant={variant}>{label}</Badge>
      <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
        <span>{value}</span>
        <CopyButton
          value={value}
          className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
        />
      </div>
    </div>
  )
}

export function BadgeSection() {
  return (
    <DsSection id="badge" title="Badge">
      <Demo label="Variants" className="flex flex-wrap items-start gap-6">
        {VARIANTS.map(({ variant, label }) => (
          <VariantDemo key={variant} variant={variant} label={label} />
        ))}
      </Demo>
    </DsSection>
  )
}
